import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Model from "../Model";
import tw from "tailwind-styled-components";
import {
    CancelBtn,
    InputGroup,
    Label,
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import Config from "../../Config";

const validationSchema = Yup.object({
    roomNumber: Yup.string()
        .min(1, "Flat name/number must be at least 1 character.")
        .max(5, "Flat name/number must be at most 5 characters.")
        .required("Flat name/number is required."),
});

const EditFlat = ({
    setFlatModel,
    selectedData,
    editFlatNumberLoading,
    editFlatNumberMutate,
    activateFlatLoading,
    activateFlatMutate,
    deactivateFlatLoading,
    deactivateFlatMutate,
    updateTenantPrefLoading,
    updateTenantPrefMutate,
}) => {
    const initialValues = {
        roomNumber: selectedData?.flatName || "",
        flatId: selectedData?.flatId,
    };

    const [tenantPreference, setTenantPreference] = useState(
        selectedData?.gender ?? 0
    );

    const handleEditSubmit = (values) => {
        editFlatNumberMutate({
            flatId: selectedData.flatId,
            newName: values.roomNumber,
        });
    };

    const handleRoomStatus = () => {
        if (selectedData.flatStatus === Config.FLAT_STATUS.INACTIVE) {
            activateFlatMutate({
                flatId: selectedData.flatId
            });
        } else if (selectedData.flatStatus === Config.FLAT_STATUS.ACTIVE) {
            deactivateFlatMutate({
                flatId: selectedData.flatId
            });;
        }
    };
    const isActivateRoom = selectedData.flatStatus === Config.FLAT_STATUS.INACTIVE;
    const buttonText = isActivateRoom ? "Activate Flat" : "Deactivate Flat";
    const isLoading = isActivateRoom ? activateFlatLoading : deactivateFlatLoading;
    const loadingText = isActivateRoom ? "Activating..." : "Deactivating...";
    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setFlatModel}
            title="Edit Flat"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleEditSubmit}
            >
                {() => (
                    <Form>
                        {/* <InputGroup>
                            <Label>Flat No.</Label>
                            <Field
                                type="text"
                                name="roomNumber"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter Room No."
                            />
                            <ErrorMessage
                                name="roomNumber"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 my-4">
                            <SideCancelBtn onClick={() => setFlatModel(false)}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn type="submit" disabled={editFlatNumberLoading} >
                                {" "}
                                {editFlatNumberLoading ? "Editing..." : "Edit"}
                            </SubmitBtn>
                        </div> */}


                        <div className="bg-gray-50 border border-gray-100 rounded-md p-5">
                            {/* <div className="mb-4">
                                <h4 className="text-sm font-semibold text-gray-900">
                                    Flat Details
                                </h4>
                                <p className="text-xs text-gray-500 mt-1">
                                    Update the flat number.
                                </p>
                            </div> */}

                            <InputGroup className="mb-0">
                                <Label className="text-xs font-medium text-gray-600 mb-2 block">
                                    Flat Number
                                </Label>

                                <Field
                                    type="text"
                                    name="roomNumber"
                                    className="
                                    w-full h-12 px-4
                                    bg-white
                                    border border-gray-200
                                    rounded-md
                                    text-gray-900
                                    placeholder:text-gray-400
                                    transition-all duration-200
                                    focus:outline-none
                                    focus:border-primary-color
                                    focus:ring-4 focus:ring-primary-color/10"
                                    placeholder="e.g. A-101"
                                />

                                <ErrorMessage
                                    name="roomNumber"
                                    component="div"
                                    className="text-red-500 text-xs mt-2"
                                />
                            </InputGroup>

                            <div className="flex gap-3 mt-5">
                                <button
                                    type="button"
                                    onClick={() => setFlatModel(false)}
                                    className="
                                    flex-1 h-11
                                    rounded-md
                                    border border-gray-200
                                    bg-white
                                    text-gray-700
                                    font-medium
                                    hover:bg-gray-50
                                    transition-all
                                "
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    disabled={editFlatNumberLoading}
                                    className="
                                    flex-1 h-11
                                    rounded-md
                                    bg-primary-color
                                    text-white
                                    font-medium
                                    shadow-md
                                    hover:opacity-90
                                    disabled:opacity-50
                                    disabled:cursor-not-allowed
                                    transition-all
                                "
                                >
                                    {editFlatNumberLoading ? (
                                        <div className="text-white flex items-center justify-center gap-2">
                                            {/* <Loading width="w-4" /> */}
                                            Saving...
                                        </div>
                                    ) : (
                                        "Save Changes"
                                    )}
                                </button>
                            </div>
                        </div>

                        {/* Tenant Preference */}
                        <div className="mt-4 border-t border-gray-100 pt-4">
                            <div className="mb-3">
                                <h4 className="font-medium text-gray-900">
                                    Tenant Preference
                                </h4>

                                <p className="text-xs text-gray-500">
                                    Controls which tenants can be assigned to this flat.
                                </p>
                            </div>

                            <div className="grid grid-cols-3 gap-3">
                                {[
                                    { value: 1, label: "Male", icon: "👨" },
                                    { value: 2, label: "Female", icon: "👩" },
                                    { value: 3, label: "Co-Living", icon: "👥" },
                                ].map(item => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        onClick={() => setTenantPreference(item.value)}
                                        className={`
                                                rounded-md border p-3 transition-all
                                                ${tenantPreference === item.value
                                                ? "border-primary-color bg-primary-color/5"
                                                : "border-gray-200 hover:border-gray-300"
                                            }
                                        `}
                                    >
                                        {/* <div className="text-xl">{item.icon}</div> */}
                                        <div className="text-xs font-medium">
                                            {item.label}
                                        </div>
                                    </button>
                                ))}
                            </div>

                            <button
                                type="button"
                                onClick={() =>
                                    updateTenantPrefMutate({
                                        flatId: selectedData.flatId,
                                        gender: tenantPreference,
                                    })
                                }
                                className="w-full mt-4 h-12 rounded-md bg-primary-color/5 border border-primary-color text-primary-color font-medium hover:bg-primary-color/20"
                            >
                                Update Tenant Preference
                            </button>
                        </div>

                        {/* Deactivate Flat */}
                        <div className="mt-4 border-t border-gray-100 pt-4">
                            <div className="mb-3">
                                <h4 className="font-medium text-gray-900">
                                    Flat Status
                                </h4>
                                <p className="text-xs text-gray-500">
                                    Only vacant flats can be deactivated.
                                </p>
                            </div>

                            <button
                                type="button"
                                onClick={handleRoomStatus}
                                disabled={selectedData.status !== Config.ROOM_STATUS.VACANT && selectedData.status !== Config.ROOM_STATUS.INACTIVE}
                                className={`
                                        w-full h-12 rounded-md font-medium transition-all
                                        ${isActivateRoom
                                        ? "bg-green-50 text-green-700 border border-green-200"
                                        : "bg-red-50 text-red-700 border border-red-200"
                                    }`}
                            >
                                {isLoading ? loadingText : buttonText}
                            </button>
                        </div>


                        {/* <DeactivateRoomBtn
                            type="button"
                            onClick={handleRoomStatus}
                            disabled={selectedData.status !== Config.ROOM_STATUS.VACANT && selectedData.status !== Config.ROOM_STATUS.INACTIVE}
                            className={`w-full border items-center mb-2 h-12 rounded-lg 
                                ${isActivateRoom ? "border-green-500 text-green-500" : "border-red-500 text-red-500"}
                                disabled:opacity-50 disabled:cursor-not-allowed
                            `}
                        >
                            {isLoading ? (
                                loadingText
                            ) : (
                                buttonText
                            )}
                        </DeactivateRoomBtn> */}
                        {/* <span className="text-center items-center flex justify-center text-sm text-gray-400">A flat must be vacant in order to be deactivate.</span> */}
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

const SubTitle = tw.p`text-sm md:text-base text-left mb-6 text-gray-700 text-pretty pt-2`;
const DeactivateRoomBtn = tw.button`w-full border border-red-500 items-center mb-2 text-red-500 h-12 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed`;

export default EditFlat;